import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133082ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sdds-message-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "sdds-card-container" }
const _hoisted_6 = {
  "data-test-id": "headerMessage",
  class: "sdds-card-headline"
}
const _hoisted_7 = { "data-test-id": "bodyMessage" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SddsMessage',
  props: {
    type: {
        type: String,
        required: true,
    },
    headerMessage: {
        type: String,
        required: true,
    },
    bodyMessage: {
        type: String,
    },
},
  setup(__props) {

const props = __props


// eslint-disable-next-line




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sdds-card sdds-message", { 'sdds-message-info': __props.type === 'info' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, [
        (_openBlock(), _createElementBlock("svg", {
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          class: _normalizeClass(["sdds-svg-icon", { 'sdds-svg-icon-info': __props.type === 'info' }])
        }, _hoisted_4, 2))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("h6", _hoisted_6, _toDisplayString(__props.headerMessage), 1)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.bodyMessage), 1)
    ])
  ], 2))
}
}

})